// Angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Import modules
import { PipesModule } from '../pipes/pipes.module';
import { ModalModule } from '../modal/modal.module';
import { ModalsModule } from '../modals/modals.module';

// Import components
import { MenuBarComponent } from './menu-bar/menu-bar.component';
import { UndoRedoComponent } from './components/undo-redo/undo-redo.component';
import { MainMenuBarOptionsComponent } from './main-menu-bar-options/main-menu-bar-options.component';
import { VersionDropdownComponent } from './components/version-dropdown/version-dropdown.component';
import { HourlyRateDropdownComponent } from './components/hourly-rate-dropdown/hourly-rate-dropdown.component';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [MenuBarComponent, UndoRedoComponent, MainMenuBarOptionsComponent, VersionDropdownComponent, HourlyRateDropdownComponent],
    imports: [
        CommonModule, PipesModule, ModalModule, ModalsModule, MatSlideToggleModule, FormsModule, MatButtonToggleModule
    ],
    exports: [MenuBarComponent, MatSlideToggleModule, MatButtonToggleModule]
})
export class MenuBarModule { }
